import React, { useEffect, useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import SVG from 'react-inlinesvg';
import ChevronRightIcon from '../../../../../../../../../assets/images/reskin-images/icon--chevrons-right.svg';
import { adminAPI } from '../../../../../../api';
import FormLoader from '../../../../../../components/FormLoader';
import useAlarm from '../../../../../../context/AlarmContext';
import { useParams } from 'react-router-dom';

const ExampleForm = ({ id, type, setOpenSideActionBoard }) => {
  const { behaviorId } = useParams();
  const { setAlarm } = useAlarm();
  const [formData, setFormData] = useState({
    description: '',
    enabled: false,
  });

  const { data: example, refetch } = useQuery(
    ['getExampleDetails', { id }],
    adminAPI.getExampleDetails,
    {
      enabled: type === 'edit' || type === 'view',
    }
  );

  useEffect(() => {
    if (type === 'edit' || type === 'view') {
      refetch();
    }
  }, [id, refetch, type]);

  useEffect(() => {
    if (example) {
      setFormData({
        description: example.description || '',
        enabled: example.enabled || false,
      });
    }
  }, [example]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const { mutate: createExampleMutation, isLoading: createLoading } =
    useMutation(adminAPI.createExample, {
      onSuccess: () => {
        refetch();
        setOpenSideActionBoard();
        setAlarm({ type: 'success', message: 'Example created successfully' });
        window.location.reload();
      },
      onError: (error) => {
        setOpenSideActionBoard();
        setAlarm({ type: 'error', message: error.message });
      },
    });

  const { mutate: updateExampleMutation, isLoading: updateLoading } =
    useMutation(adminAPI.updateExampleDetails, {
      onSuccess: () => {
        setOpenSideActionBoard();
        setAlarm({ type: 'success', message: 'Example updated successfully' });
        window.location.reload();
      },
      onError: (error) => {
        setOpenSideActionBoard();
        setAlarm({ type: 'error', message: error.message });
      },
    });

  const handleSubmit = (e) => {
    e.preventDefault();
    const exampleData = {
      ...formData,
    };
    if (type === 'create') {
      createExampleMutation({
        behaviorId,
        exampleData,
      });
    } else if (type === 'edit') {
      updateExampleMutation({ id, exampleData });
    }
  };

  const isDetailView = type === 'view';

  const label = {
    view: 'View Example',
    edit: 'Edit Example',
    create: 'Create Example',
  };

  return (
    <>
      <div className="flex justify-between items-center relative pb-4 px-8">
        <button
          className="p-2 flex items-center -ml-2"
          type="button"
          onClick={() => setOpenSideActionBoard()}
        >
          <SVG src={ChevronRightIcon} />
        </button>
        <span
          style={{ width: 'calc(100% + 6rem)' }}
          className="absolute pin-b pin-r -mx-16 h-px bg-gray flex"
        />
      </div>

      <form
        className="overflow-y-scroll h-full px-8 py-8"
        onSubmit={handleSubmit}
      >
        <h1>{label[type]}</h1>

        <div style={{ gap: '16px' }} className="flex flex-col my-12">
          <div className="mb-6">
            <label className="font-semibold text-gray-700">Description</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-purple-600"
              rows="4"
              disabled={isDetailView}
            />
          </div>
        </div>

        {!isDetailView && (
          <button
            className="mb-20 p-4 bg-purple-500 text-white font-semibold rounded-lg hover:bg-purple-700 transition-colors"
            type="submit"
          >
            {type === 'create' ? 'Create Example' : 'Update Example'}
          </button>
        )}

        {(createLoading || updateLoading) && <FormLoader />}
      </form>
    </>
  );
};

export default ExampleForm;
